/*
 * zeroLabs Startseite: Die Zahl antwortet auf Antippen (sections/zl-start-zahl.liquid, Gestaltung assets/zl-start-zahl.css).
 * Und eins für dich: Die letzte Ziffer rollt eine weiter, darunter steht kurz „Und eins für dich.“, dann rollt sie
 * zurück. Nur mit data-deins an der Sektion, bei reduzierter Bewegung passiert nichts.
 */
(() => {
  'use strict';
  const el = document.querySelector('[data-zl-zahl][data-deins]');
  if (!el) return;
  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Zeiten mit Einheit lesen: Shopify schreibt 2400ms als 2.4s */
  const zeitMs = (name) => {
    const roh = getComputedStyle(el).getPropertyValue(name).trim();
    return (/\ds$/.test(roh) && !/ms$/.test(roh) ? parseFloat(roh) * 1000 : parseFloat(roh)) || 0;
  };
  let zurueck = 0;
  el.querySelector('.zl-zahl__zahl').addEventListener('click', () => {
    if (ruhig.matches) return;
    el.classList.add('is-deins');
    clearTimeout(zurueck);
    zurueck = setTimeout(() => el.classList.remove('is-deins'), zeitMs('--zl-start-zahl-deins'));
  });
})();
